
		<div class="form-group"
		     [ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-3 control-label" for="{{OBJ_field_config.name}}">{{getLabelName()|translate}}
				<i *ngIf="getHint()" class="fa fa-info-circle"
				   tooltip="{{getHint()|translate}}"
				   placement="top"
				   triggers="click"
				   containerClass="tig-tooltip"
				   delay="50"></i>
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<textarea
					#field="ngModel"
					[required]="isRequired()"
					type="text"
					class="form-control"
					id="{{OBJ_field_config.name}}"
					name="{{OBJ_field_config.name}}"
					[(ngModel)]="OBJ_data[OBJ_field_config.name]">
				</textarea>
				<span class="help-block m-b-none" *ngIf="isInvalid()">
                  {{'oError.sRequired'|translate}}
                </span>
			</div>
		</div>
	